import { render, staticRenderFns } from "./CustomerImportEmailPreview.vue?vue&type=template&id=b3247442&scoped=true&"
import script from "./CustomerImportEmailPreview.vue?vue&type=script&lang=ts&"
export * from "./CustomerImportEmailPreview.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerImportEmailPreview.vue?vue&type=style&index=0&id=b3247442&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3247442",
  null
  
)

export default component.exports